<template>
  <div class="default_btn">
    {{ text }}
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'DefaultButton',
  props: {
    text: String
  }
});
</script>

<style scoped>
.default_btn {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 42px;
  color: rgb(255, 255, 255);
  width: 337px;
  height: 70px;
  border-radius: 20px;
  border: 6px solid transparent;
  background: linear-gradient(rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.9)) padding-box,
    linear-gradient(to bottom, #d8d8d8 0%, #808080 100%) border-box;
}
</style>
